"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesTagsSettings = void 0;
// -- CORE -- //
const React = __importStar(require("react"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const tags_1 = require("companion-app-components/flux/tags");
const categories_1 = require("companion-app-components/flux/categories");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const memorizedRulesSelectors_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesSelectors");
const memorizedRulesActions_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesActions");
// -- MUI -- //
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const mui_1 = require("tss-react/mui");
// -- DATA -- //
const under_construction_png_1 = __importDefault(require("assets/under-construction.png"));
const transactionSelectors = __importStar(require("data/transactions/selectors"));
// -- SHARED -- //
const QButton_1 = __importDefault(require("components/QButton"));
const QData_1 = __importDefault(require("components/QData"));
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog")); // eslint-disable-line import/no-named-as-default-member
// -- LOCAL -- //
const TagsSettings_1 = __importDefault(require("./TagsSettings"));
const CategoriesSettings_1 = __importDefault(require("./CategoriesSettings"));
const styles = (theme) => ({
    underConstruction: {
        display: 'block',
        width: '50%',
        marginTop: theme.spacing(5),
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    dialogTitleRoot: {
        margin: 0,
        padding: theme.spacing(3),
        backgroundColor: theme.mixins.register.headerBackground,
    },
    dialogCloseButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(2),
    },
    dialogContentRoot: {
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    dialogContentText: {
        color: theme.palette.text.primary,
    },
    dialogActionsRoot: {
        margin: 0,
        padding: theme.spacing(3),
    },
    dialogActionsButton: {
        margin: `0 ${theme.spacing(1)}`,
    },
});
const dialogActions = {
    CLOSE: 'Close',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    KEYDOWN: 'KeyDown',
};
const useStyles = (0, mui_1.makeStyles)()(styles);
const CategoriesTagsSettings = (props) => {
    const { batchTransactions } = props;
    const { classes } = useStyles();
    const categoriesTagsEnabled = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('categoryTagsManagement'));
    const scheduledTransactions = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getUserVerifiedScheduledTransactions(state));
    const transactionsById = (0, react_redux_1.useSelector)((state) => transactionSelectors.getTransactionsById(state));
    const memTransactionsById = (0, react_redux_1.useSelector)((state) => (0, memorizedRulesSelectors_1.getMemorizedRulesById)(state));
    const tags = (0, react_redux_1.useSelector)((state) => tags_1.tagsSelectors.getTags(state));
    const tagsCharFilter = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('tagsCharFilter'));
    const tagsIsLoading = (0, react_redux_1.useSelector)((state) => tags_1.tagsSelectors.getIsLoading(state));
    const categories = (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getCategoriesById(state));
    const categoriesIsLoading = (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getIsLoading(state));
    const dispatch = (0, react_redux_1.useDispatch)();
    const updateScheduledTransaction = (data) => dispatch(scheduled_transactions_1.scheduledTransactionsActions.updateScheduledTransaction(data));
    const updateMemTransactions = (data) => dispatch((0, memorizedRulesActions_1.combineMemorizedRules)(data));
    const getTags = () => dispatch(tags_1.tagsActions.getTags());
    const createTag = (data) => dispatch(tags_1.tagsActions.createTag(data, {
        undo: { userMessage: 'Tag created.' },
    }));
    const updateTag = (data) => dispatch(tags_1.tagsActions.updateTag(data, {
        undo: { userMessage: 'Tag updated.' },
    }));
    const deleteTag = (data, txns, schedTxns, memPayees) => {
        dispatch(tags_1.tagsActions.deleteTag(data, {
            undo: { userMessage: 'Tag deleted.' },
            txns,
            schedTxns,
        }));
        if ((memPayees === null || memPayees === void 0 ? void 0 : memPayees.size) > 0) {
            updateMemTransactions(memPayees);
        }
    };
    const getCategories = () => dispatch(categories_1.categoriesActions.getCategories());
    const createCategory = (data) => dispatch(categories_1.categoriesActions.createCategory(data, {
        undo: { userMessage: 'Category created.' },
    }));
    const updateCategory = (data) => dispatch(categories_1.categoriesActions.updateCategory(data, {
        undo: { userMessage: 'Category updated.' },
    }));
    const batchCategories = (data) => dispatch(categories_1.categoriesActions.batchCategories(data));
    const deleteCategory = (data) => dispatch(categories_1.categoriesActions.deleteCategory(data, {
        undo: { userMessage: 'Category deleted.' },
    }));
    const [dialog, setDialog] = (0, react_1.useState)(null);
    const setDialogFunction = (title, content, callback, buttons) => {
        const newDialog = {
            title, content, callback, buttons,
        };
        setDialog(newDialog);
    };
    const clearDialog = () => {
        setDialog(null);
    };
    const dispatchDialogAction = (action) => {
        const { callback = null } = dialog;
        let dispatchAction = action;
        return (event, reason) => {
            if (dispatchAction === dialogActions.KEYDOWN && event.key === 'Enter') {
                dispatchAction = dialogActions.ENTER;
            }
            else if (reason === 'escapeKeyDown') {
                dispatchAction = dialogActions.ESCAPE;
            }
            if (dispatchAction !== dialogActions.KEYDOWN) {
                if (callback) {
                    callback({ action: dispatchAction });
                }
                clearDialog();
            }
        };
    };
    const txnsProps = {
        updateScheduledTransaction,
        scheduledTransactions,
        transactionsById,
        batchTransactions,
        memTransactionsById,
        updateMemTransactions,
    };
    if (!categoriesTagsEnabled) {
        return (<img className={classes.underConstruction} alt="page is under construction" src={under_construction_png_1.default}/>);
    }
    return (<div>
      <Grid_1.default container>
        <TagsSettings_1.default isLoading={tagsIsLoading} data={tags} getItems={getTags} createItem={createTag} updateItem={updateTag} deleteItem={deleteTag} tagsCharFilter={tagsCharFilter} txnsProps={txnsProps}/>
        <CategoriesSettings_1.default isLoading={categoriesIsLoading} // TODO: add isLoading functionality to reducers and include it here
     data={categories} getItems={getCategories} createItem={createCategory} updateItem={updateCategory} updateItems={batchCategories} deleteItem={deleteCategory} txnsProps={txnsProps} setDialog={setDialogFunction}/>
      </Grid_1.default>

      {dialog !== null &&
            <StdDialog_1.default aria-labelledby="categories-tags-dialog-title" open title={dialog.title} onClose={dispatchDialogAction(dialogActions.CLOSE)}>
          <DialogContent_1.default className={classes.dialogContentRoot}>
            <Typography_1.default variant="body1" component="div" className={classes.dialogContentText}>{dialog.content}</Typography_1.default>
          </DialogContent_1.default>
          <DialogActions_1.default>
            {dialog.buttons.map((btn, i) => {
                    const variant = i === dialog.buttons.length - 1 ? 'contained' : 'outlined';
                    return (<QButton_1.default id={`dialog_${btn.split(' ').join('_')}`} key={btn} className={classes.dialogActionsButton} variant={variant} onClick={dispatchDialogAction(btn)}>
                  {btn}
                </QButton_1.default>);
                })}
          </DialogActions_1.default>
        </StdDialog_1.default>}
    </div>);
};
exports.CategoriesTagsSettings = CategoriesTagsSettings;
exports.default = (0, QData_1.default)()(exports.CategoriesTagsSettings);
